import { Box } from "../Box/Box";
import { FlexContainer } from "../Container/FlexContainer";
import { Div } from "../Div";
import { Img } from "../Img";
import { TextField } from "../TextField";
import { toMap } from "../../../../HA";

export class MenuItem extends Box {
    protected createSelf() {
        super.createSelf();
        this.addClass("menui");
        const cont = new FlexContainer();
        const logo = this.get("l");

        if (logo instanceof Object) {
            const img2 = new Div(toMap(logo));
            img2.addClass("medc");
            cont.appendChild(img2);
        } else {
            const img = new Div();
            img.addClass("medc");
            img.appendChild(new Img(toMap({src: logo})));
            cont.appendChild(img);
        }

        cont.appendChild(new TextField(this.get("n")));
        this.appendChild(cont);
    }
}
